import tw, { styled } from 'twin.macro';

export type TagType = 'default' | 'delivered' | 'emergency' | 'nonMaintenance' | 'pending' | 'processing';

export interface TagProps {
  type?: TagType;
  children?: React.ReactNode;
}

const StyledTag = styled.span<Omit<TagProps, 'content'>>(({ type }) => [
  tw`flex items-center gap-1 px-2 py-1 text-sm text-center rounded-lg bg-background-secondary max-w-max flex-nowrap whitespace-nowrap`,
  type === 'default' && tw`text-white bg-primary`,
  type === 'delivered' && tw`bg-success-light text-success`,
  type === 'emergency' && tw`bg-alert-light text-alert`,
  type === 'nonMaintenance' && tw`bg-background-secondary text-text-medium-dark`,
  type === 'pending' && tw`bg-pending-light text-pending`,
  type === 'processing' && tw`bg-processing-light text-processing`,
]);

export const Tag: React.FC<TagProps> = ({ type = 'default', children }) => {
  return <StyledTag type={type}>{children}</StyledTag>;
};

export default Tag;
